import React, {useEffect, useState} from 'react';
import {Event, PageView} from "../GoogleAnalytics";
import {
    assetType,
    ColumnSortTypes,
    Equipment,
    jsAlert,
    jsAsset,
    jsCustomer,
    TagIdsEnum,
    TriageActions
} from "../../componentObjects";
import ArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CommonExpandTable from "../CommonTable/CommonExpandTable";
import Loader from "../Loader/Loader";
import AlertService from "../../services/alerts.service";
import alerttypemessagingService from "../../services/alerttypemessaging.service";
import CommentsService from "../../services/comments.service";
import Tooltip from "@mui/material/Tooltip";
import NotificationIcon from "@mui/icons-material/NotificationsActiveOutlined";
import SummarizedAlertsModal from "../TriageAlerts/SummarizedAlertsModal";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import Snackbar from "@mui/material/Snackbar";
import ViewGraphButton from "../TriageAlerts/ViewGraphButton";
import DeviceService from "../../services/device.service";
import SensorMapModal from "../Devices/SensorMapModal";
import AlerttypeService from "../../services/alerttype.service";
import AlertTypeModal from "../InternalTriageAlerts/AlertTypeModal";
import moment from "moment/moment";

const SENSOR_PROPS = [
    "Current",
    "BlowerCurrent",
    "InducerCurrent"
];
const CURRENT_STR = "Current";
const BLOWER_CURRENT_STR = "BlowerCurrent";
const INDUCER_CURRENT_STR = "InducerCurrent";
const UNMAPPED_STR = "Unmapped";

const BLOWER_CURRENT_ALERT_NAME = "Sensor Mapping - Blower Current Over Main";
const INDUCER_CURRENT_ALERT_NAME = "Sensor Mapping - Inducer Current Over Main";
const MULTI_SENSOR_ALERT_NAME = "Sensor Mapping - Remap Sensors";

function AnalyticAlerts(props) {
    const { _isMounted, isLoading, userId, currentUser } = props;
    const [isMounted, setIsMounted] = useState(false);
    const [contentLoading, setContentLoading] = useState(false);
    const [isSelected, setIsSelected] = useState(-1);
    const [editAlert, setEditAlert] = useState(jsAlert);
    const [currentAlert, setCurrentAlert] = useState(jsAlert);
    const [currentAsset, setCurrentAsset] = useState(jsAsset);
    const [currentCustomer, setCurrentCustomer] = useState(jsCustomer);
    const [acSelected, setAcSelected] = useState(false);
    const [tableObj, setTableObj] = useState({});
    const [alertList, setAlertList] = useState([]);
    const [analyticAlerts, setAnalyticAlerts] = useState([]);
    const [consolidateAlertsDict, setConsolidateAlertsDict] = useState({});
    const [statusMessage, setStatusMessage] = useState("");
    const [showMessage, setShowMessage] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [modalTitle, setModalTitle] = useState("");
    const [alertMessaging, setAlertMessaging] = useState({});
    const [assetComments, setAssetComments] = useState([]);
    const [graphLoaded, setGraphLoaded] = useState(false);
    const [alertDetailLoading, setAlertDetailLoading] = useState(false);
    const [alertMsgObj, setAlertMsgObj] = useState({});
    const [showCloseAlertConfirm, setShowCloseAlertConfirm] = useState(false);
    const [showSummarizedAlerts, setShowSummarizedAlerts] = useState(false);
    const [showGraph, setShowGraph] = useState(false);
    
    const [showRemapSensorConfirm, setShowRemapSensorConfirm] = useState(false);
    const [showRepairSensorMapConfirm, setShowRepairSensorMapConfirm] = useState(false);
    
    const [sensorsLoading, setSensorsLoading] = useState(false);
    const [currentSensor, setCurrentSensor] = useState(null);
    const [secondSensor, setSecondSensor] = useState(null);
    const [sensorList, setSensorList] = useState([]);
    const [unmappedSensorList, setUnmappedSensorList] = useState([]);
    
    const [unmappedProperties, setUnmappedProperties] = useState([]);
    const [mappedSensors, setMappedSensors] = useState([]);
    const [unmappedSensors, setUnmappedSensors] = useState([]);
    const [mapDict, setMapDict] = useState({});
    
    const [unmapPropsList, setUnmapPropsList] = useState([]);
    const [remapPropsList, setRemapPropsList] = useState([]);
    
    const [analyticAlertTypes, setAnalyticAlertTypes] = useState([]);
    const [blowerCurrentAlertTypeId, setBlowerCurrentAlertTypeId] = useState(null);
    const [inducerCurrentAlertTypeId, setInducerCurrentAlertTypeId] = useState(null);
    const [multiSensorAlertTypeId, setMultiSensorAlertTypeId] = useState(null);
    
    const [showChangedAlertType, setShowChangedAlertType] = useState(false);
    const [alertTypes, setAlertTypes] = useState([]);
    
    useEffect(() => {
        setIsMounted(true);
        setContentLoading(true);
        PageView();

        if (!isLoading) {
            populateAlertData();
        }

        return () => {
            setIsMounted(false);
        };
    }, [isMounted]);
    
    const populateAlertData = () => {
        if (_isMounted && isMounted) {
            setContentLoading(true);
            setIsSelected(-1);
            setCurrentAlert(jsAlert);

            alerttypemessagingService.getalertmessaging()
                .then(async response => {
                    if (_isMounted) {
                        setAlertMessaging(response);
                    }

                    await CommentsService.getassetcomments()
                        .then(async response2 => {
                            if (_isMounted) {
                                setAssetComments(response2.data);
                                
                                AlerttypeService.getanalyticalerttypes()
                                    .then(response4 => {
                                        setAnalyticAlertTypes(response4);
                                        let blowerId = response4?.find(t => t.name === BLOWER_CURRENT_ALERT_NAME)?.alertTypeId;
                                        let inducerId = response4?.find(t => t.name === INDUCER_CURRENT_ALERT_NAME)?.alertTypeId;
                                        let multiId = response4?.find(t => t.name === MULTI_SENSOR_ALERT_NAME)?.alertTypeId;
                                        setBlowerCurrentAlertTypeId(blowerId);
                                        setInducerCurrentAlertTypeId(inducerId);
                                        setMultiSensorAlertTypeId(multiId);
                                    })
                                    .catch(e => {
                                        console.log(e);
                                    })
                                
                                AlertService.getanalyticalerts()
                                    .then(response3 => {
                                        setTableObj(response3?.data);
                                        setAlertList(response3?.data?.alerts);
                                        setAnalyticAlerts(response3?.data?.analyticAlerts);
                                        consolidateAlerts(response3?.data?.alerts);
                                        setContentLoading(false);
                                    })
                                    .catch(e => {
                                        console.log(e);
                                        setContentLoading(false);
                                    });
                            }
                        })
                        .catch(e => {
                            console.log(e);
                            setContentLoading(false);
                        })
                })
                .catch(e => {
                    console.log(e);
                    setContentLoading(false);
                });
        }
    }
    
    const consolidateAlerts = (alerts) => {
        let distinctAlerts = [];
        let consolidateAlertsDict = {};// {{ assetId: assetId used in consolidateDict }}

        for (let i = 0; i < alerts.length; i++) {
            let currAlert = alerts[i];

            if (!distinctAlerts.some(a => a.typeId === currAlert.typeId && a.assetId === currAlert.assetId)) {
                let assetTypeAlerts = alerts.filter(a => a.typeId === currAlert.typeId && a.assetId === currAlert.assetId);
                let alertConversationId = Math.max(...assetTypeAlerts.map(o => o.conversationId)).toString();
                let alertCommentCount = assetTypeAlerts.find(a => a.conversationId === alertConversationId);

                assetTypeAlerts.sort((a, b) => {
                    const startA = new Date(a.startTime);
                    const startB = new Date(b.startTime);
                    return startB - startA;
                });

                let distinctAlert = [...assetTypeAlerts][0];
                
                if (alertConversationId !== "0") {
                    distinctAlert.conversationId = alertConversationId;
                    distinctAlert.commentsCount = alertCommentCount.conversationItemCount;
                    distinctAlert.conversationItemCount = alertCommentCount.conversationItemCount;
                }
                distinctAlerts = distinctAlerts.concat(distinctAlert);

                if (consolidateAlertsDict[currAlert.typeId] === undefined) {
                    consolidateAlertsDict[currAlert.typeId] = {};
                    consolidateAlertsDict[currAlert.typeId][currAlert.assetId] = assetTypeAlerts;
                }
                else {
                    consolidateAlertsDict[currAlert.typeId][currAlert.assetId] = assetTypeAlerts;
                }
            }
        }
        distinctAlerts = distinctAlerts.map(alert => {
            return {
                ...alert,
                count: consolidateAlertsDict[alert.typeId]?.[alert.assetId]?.length || 0,
             
            };
        });
        
        distinctAlerts.sort((a, b) => {
            let aAlerts = consolidateAlertsDict[a.typeId][a.assetId];
            let bAlerts = consolidateAlertsDict[b.typeId][b.assetId];
            if (!aAlerts.some(c => c.tagIds.includes(TagIdsEnum.NewAlert))) {
                if (!bAlerts.some(d => d.tagIds.includes(TagIdsEnum.NewAlert))) {
                    return 0;
                }
                else {
                    return 1;
                }
            }
            else {
                if (!bAlerts.some(d => d.tagIds.includes(TagIdsEnum.NewAlert))) {
                    return -1;
                }
                else {
                    return 0;
                }
            }
        });
        
        setAlertList(distinctAlerts);
        setConsolidateAlertsDict(consolidateAlertsDict);
        setContentLoading(false);
    }
    
    function getCurrentAssetTypeId(assetClassNames) {
        let assetTypeId = assetType.General;
        if (assetClassNames !== null && assetClassNames !== undefined && assetClassNames.length) {
            if (assetClassNames.some(a => a === Equipment.AIR_CONDITIONER)) {
                assetTypeId = assetType.AirConditioner;
            }
            else if (assetClassNames.some(a => a === Equipment.FURNACE)) {
                assetTypeId = assetType.Furnace;
            }
            else if (assetClassNames.some(a => a === Equipment.AIR_HANDLER)) {
                assetTypeId = assetType.AirHandler;
            }
            else if (assetClassNames.some(a => a === Equipment.HEAT_PUMP)) {
                assetTypeId = assetType.HeatPump;
            }

        }
        return assetTypeId;
    }
    
    function getAlertMsgObj(alertTypeId) {
        let alertMsg = {};
        const alertMsgList = alertMessaging.filter(a => a.id.toString() === alertTypeId);
        let alertMsgObj = {};
        if (alertMsgList.length > 1) {
            let assetTypeId = getCurrentAssetTypeId(currentAlert.assetClassNames);
            alertMsgObj = alertMessaging.find(a => a.id.toString() === alertTypeId && a.assetTypeId === assetTypeId);
            if (alertMsgObj !== null && alertMsgObj !== undefined) {
                alertMsg = alertMsgObj;
            }
            else {
                alertMsgObj = alertMessaging.find(a => a.id.toString() === alertTypeId && a.assetTypeId === assetType.General);
                if (alertMsgObj !== null && alertMsgObj !== undefined) {
                    alertMsg = alertMsgObj;
                }
            }
        }
        else {
            let alertMsgObj = alertMessaging.find(a => a.id.toString() === alertTypeId);
            if (alertMsgObj !== null && alertMsgObj !== undefined) {
                alertMsg = alertMsgObj;
            }
        }
        return alertMsg;
    }
    
    const clearSelected = () => {
        setIsSelected(-1);
        setCurrentAlert(jsAlert);
    }
    
    const onAlertClick = async (index, rowAlert) => {
        let x = index;
        if (isSelected === x) {
            setIsSelected(-1);
            setAlertMsgObj({})
        } else {
            let alert = tableObj.alerts.find(t => t.alertId.toString() === rowAlert.alertId);

            setGraphLoaded(false);
            setIsSelected(x);
            setCurrentAlert(alert);
            setAlertDetailLoading(true);

            let alertMsg = getAlertMsgObj(alert?.typeId);
            setAlertMsgObj(alertMsg);

            await AlertService.get(alert?.organization)
                .then(async response => {
                    if (_isMounted) {
                        setCurrentCustomer(response?.data);

                        await AlertService.getalertasset(alert)
                            .then(async response2 => {
                                setCurrentAsset(response2?.data);
                                setAlertDetailLoading(false);
                            })
                            .catch(e => {
                                console.log(e);
                            });
                    }
                })
                .catch(e => {
                    console.log(e);
                });
        }
    }
    
    //expand content & helpers
    
    const openCloseAlertModal = () => {
        let localeDateAlert = new Date(currentAlert.startTime);
        setModalTitle("Close Alert");
        setModalMessage(`You are about to close this alert from ${localeDateAlert.toLocaleDateString()}, ${localeDateAlert.toLocaleTimeString()}. Are you sure?`);
        setEditAlert(currentAlert);
        showCloseAlertModal();
    }
    
    const showCloseAlertModal = () => {
        setShowCloseAlertConfirm(!showCloseAlertConfirm)
    }
    
    const onCloseAlert = async () => {
        setContentLoading(true);
        setShowCloseAlertConfirm(false);
        await closeAlerts();
    }
    
    const closeAlerts = async () => {
        Event("Close Alerts", "User closed alerts", "Close Alerts");
        let editAlerts = consolidateAlertsDict[editAlert.typeId][editAlert.assetId];
        await AlertService.triagealerts(TriageActions.CLOSE_INTERNAL, editAlerts)
            .then(response => {
                if (response.status === 200 && response.data !== undefined && response.data !== null && response.data !== false) {
                    setStatusMessage('Alerts closed successfully');
                    setShowMessage(true);
                    setContentLoading(false);
                    
                    populateAlertData();
                }
                else {
                    setStatusMessage("Failed to close alerts");
                    setShowMessage(true);
                    setContentLoading(false);
                }

                setTimeout(() => {
                    setStatusMessage("");
                    setShowMessage(false);
                }, 3000);
            })
            .catch(e => {
                console.log(e);
                setStatusMessage("Failed to close alerts");
                setShowMessage(true);
                setContentLoading(false);

                setTimeout(() => {
                    setStatusMessage("");
                    setShowMessage(false);
                }, 3000);
            });
    }
    
    const getMapProperties = (assetProperties, isMultiCT) => {
        let props = [];
        let currentProps = [];
        let propIds = [];
        if (isMultiCT) {
            let flycatcherProps = SENSOR_PROPS;
            currentProps = assetProperties.filter(p => flycatcherProps.includes(p.name));
        }
        else {
            currentProps = assetProperties.filter(p => p.name === CURRENT_STR);
        }
        props = currentProps;
        
        return props;
    }
    
    const openRemapSensorsModal = async (alert) => {
        setSensorsLoading(true);
        setEditAlert(currentAlert);
        setModalTitle("Remap Sensors");
        let isBlowerAlert = alert?.typeId.toString() === blowerCurrentAlertTypeId.toString();
        let sensorType = isBlowerAlert ? 'blower current' : 'inducer current';
        setModalMessage("You are about to swap the " + sensorType + " sensor and the main current sensor. Continue?");
        await DeviceService.getsensormapitems(currentAsset?.furnaceMAC?.split('-')[0])
            .then(response => {
                if (_isMounted) {
                    let sensors = response.data;
                    let isMultiCT = true;//this.state.isFlyCatcher;

                    let unmappedProps = getMapProperties(currentAsset.properties, isMultiCT);
                    let mapDict = {};
                    let unmapList = [];
                    let remapList = [];
                    let currentSensor = null;
                    let secondSensor = null;
                    let currentProperty = {};
                    let secondProperty = {};
                    let mappedSensors = [];
                    let macID = currentAsset?.furnaceMAC;
                    if (sensors !== null && sensors !== undefined && sensors.length) {
                        let flycatcherProps = SENSOR_PROPS;
                        mappedSensors = sensors.filter(s => (flycatcherProps.find(f => s.mappedTo.includes(f)) !== undefined) && s.mappedTo.includes(macID));
                        currentSensor = mappedSensors.find(m => m.mappedTo.includes(" " + CURRENT_STR) && m.mappedTo.includes(macID));
                        let secondSensorProp = isBlowerAlert ? BLOWER_CURRENT_STR : INDUCER_CURRENT_STR;
                        secondSensor = mappedSensors.find(m => m.mappedTo.includes(secondSensorProp) && m.mappedTo.includes(macID));
                        
                        currentProperty = currentAsset.properties.find(a => a.name === CURRENT_STR);
                        secondProperty = currentAsset.properties.find(a => a.name === secondSensorProp);
                        let unmapCurrent = {
                            propertyId: currentProperty.propertyId,
                            name: currentProperty.name,
                            description: currentProperty.name,
                            friendlyId: currentProperty.friendlyId,
                            dataIndexId: currentSensor.indexId,
                            dataIndexName: currentSensor.name,
                            assetId: currentAsset.assetId
                        };
                        unmapList.push(unmapCurrent);
                        let unmapSecond = {
                            propertyId: secondProperty.propertyId,
                            name: secondProperty.name,
                            description: secondProperty.name,
                            friendlyId: secondProperty.friendlyId,
                            dataIndexId: secondSensor.indexId,
                            dataIndexName: secondSensor.name,
                            assetId: currentAsset.assetId
                        };
                        unmapList.push(unmapSecond);
                        
                        let remapCurrent = {
                            propertyId: currentProperty.propertyId,
                            name: currentProperty.name,
                            description: currentProperty.name,
                            friendlyId: currentProperty.friendlyId,
                            dataIndexId: secondSensor.indexId,
                            dataIndexName: secondSensor.name,
                            assetId: currentAsset.assetId
                        };
                        remapList.push(remapCurrent);
                        let remapSecond = {
                            propertyId: secondProperty.propertyId,
                            name: secondProperty.name,
                            description: secondProperty.name,
                            friendlyId: secondProperty.friendlyId,
                            dataIndexId: currentSensor.indexId,
                            dataIndexName: currentSensor.name,
                            assetId: currentAsset.assetId
                        }
                        remapList.push(remapSecond);
                        mapDict = unmappedProps.map((prop, index) => {
                            return -1;
                        });
                    }
        
                    setSensorList(sensors);
                    setCurrentSensor(currentSensor);
                    setSecondSensor(secondSensor);
                    setMappedSensors(mappedSensors);
                    setUnmappedProperties(unmappedProps);
                    setMapDict(mapDict);
                    setUnmapPropsList(unmapList);
                    setRemapPropsList(remapList);
                    setSensorsLoading(false);
                    showRemapSensorsModal();
                }
            })
            .catch(e => {
                console.log(e);
            })
    }
    
    const showRemapSensorsModal = () => {
        setShowRemapSensorConfirm(!showRemapSensorConfirm);
    }
    
    const onRemapSensorsClick = () => {
        DeviceService.unmapproperties(unmapPropsList)
            .then(response2 => {
                if (response2.data === true) {
                    let message = "Successfully unmapped properties";
                    setStatusMessage(message);
                    setShowMessage(true);

                    DeviceService.unmapproperties(remapPropsList, false)
                        .then(async response => {
                            message = "";
                            if (response.data === true) {
                                message = "Successfully remapped properties";
                                await closeAlerts();
                            }
                            else {
                                message = "Failed to remap properties";
                            }
                            
                            setStatusMessage(message);
                            setShowMessage(true);
                            setShowRemapSensorConfirm(false);

                            setTimeout(() => {
                                setStatusMessage("");
                                setShowMessage(false);
                            }, 3000);
                        })
                        .catch(e => {
                            console.log(e);
                        });
                }
                else {
                    setStatusMessage("Failed to unmap properties");
                    setShowMessage(true);
                    setShowRemapSensorConfirm(false);

                    setTimeout(() => {
                        setStatusMessage("");
                        setShowMessage(false);
                    }, 3000);
                }
            })
            .catch(e => {
                console.log(e);
            })

        setTimeout(() => {
            setStatusMessage("");
            setShowMessage(false);
        }, 3000);
    }
    
    // 'Remap' functionality performs the auto swapping of blower or inducer and main current
    // 'Repair' functionality allows user to use the sensor map modal to manually select the sensors to map
    
    const openRepairSensorMapModal = async (alert) => {
        setSensorsLoading(true);
        setEditAlert(currentAlert);
        await DeviceService.getsensormapitems(currentAsset?.furnaceMAC?.split('-')[0])
            .then(response => {
                if (_isMounted) {
                    let sensors = response.data;
                    let isMultiCT = true;

                    let unmappedProps = getMapProperties(currentAsset.properties, isMultiCT);
                    let mapDict = {};
                    let currentSensor = null;
                    let mappedSensors = [];
                    let unmappedSensorList = [];
                    let deviceId = currentAsset?.furnaceMAC;
                    if (sensors !== null && sensors !== undefined && sensors.length) {
                        let flycatcherProps = SENSOR_PROPS;
                        mappedSensors = sensors.filter(s => (flycatcherProps.find(f => s.mappedTo.includes(f)) !== undefined) && s.mappedTo.includes(deviceId.trim()));
                        currentSensor = mappedSensors.find(m => m.mappedTo.includes(" " + CURRENT_STR) && m.mappedTo.includes(deviceId));
                        sensors = sensors.filter(s => s.status === UNMAPPED_STR || mappedSensors.includes(s)); //want mapped AND active for this sensor.
                        unmappedSensorList = sensors.filter(s => s.status === UNMAPPED_STR);
                        mapDict = unmappedProps.map((prop, index) => {
                            return sensors.findIndex(s => s.mappedTo.includes(" " + prop.name) && s.mappedTo.includes(deviceId));
                        });
                    }

                    setSensorList(sensors);
                    setUnmappedSensorList(unmappedSensorList);
                    setCurrentSensor(currentSensor);
                    setMappedSensors(mappedSensors);
                    setUnmappedProperties(unmappedProps);
                    setMapDict(mapDict);
                    setSensorsLoading(false);
                    showRepairSensorMapModal();
                }
            })
            .catch(e => {
                console.log(e);
            })
    }
    
    const showRepairSensorMapModal = () => {
        setShowRepairSensorMapConfirm(!showRepairSensorMapConfirm);
    }
    
    const onRepairSensorMapClick = () => {
        setSensorsLoading(true);

        let sensorDict = {};
        for (let i = 0; i < unmappedProperties.length; i++) {
            if (mapDict[i] !== -1) {
                let sensor = sensorList[mapDict[i]];
                let property = unmappedProperties[i];
                sensorDict[property.name] = sensor;
            }
        }

        let hvacSystemId = currentAlert?.pathIds?.length ? currentAlert.pathIds[2] : -1;
        let macId = currentAsset?.furnaceMAC;
        if (hvacSystemId > 0) {
            DeviceService.repairsensormap(hvacSystemId, macId, sensorDict)
                .then(async response => {
                    let message = "";

                    if (response.data === true) {
                        message = "Successfully repaired Sensor Map!";
                        Event("Repair Sensor Map Clicked", "User clicked repair sensor map button", "Repair Sensor Map Clicked");
                        await closeAlerts();
                    }
                    else {
                        message = "Failed to repair Sensor Map!";
                    }
                    setStatusMessage(message);
                    setShowMessage(true);
                    setShowRepairSensorMapConfirm(false);

                    setTimeout(() => {
                        setStatusMessage("");
                        setShowMessage(false);
                    }, 3000);

                })
                .catch(e => {
                    console.log(e);
                });
        }
        else {
            let message = "Couldn't determine HVAC System to remap sensors.";
            setStatusMessage(message);
            setShowMessage(true);
            setShowRepairSensorMapConfirm(false);
        }

        setTimeout(() => {
            setStatusMessage("");
            setShowMessage(false);
        }, 3000);
    }
    
    const mapSensor = (propertyIndex, sensorIndex) => {
        let updateMapDict = mapDict;
        updateMapDict.forEach((item, index) => {
            if (index === propertyIndex) {
                updateMapDict[index] = sensorIndex;
            }
            else if (updateMapDict[index] === sensorIndex) {
                updateMapDict[index] = -1;
            }
        });

        setMapDict(updateMapDict);
    }
    
    const openSummarizedAlertsModal = () => {
        setModalTitle("Summarized Alerts");
        setEditAlert(currentAlert);
        showSummarizedAlertsModal();
    }
    
    const showSummarizedAlertsModal = () => {
        setShowSummarizedAlerts(!showSummarizedAlerts);
    }
    
    const showGraphModal = () => {
        setShowGraph(!showGraph);
    }

    const openChangeAlertTypeModal = async () => {
        await AlertService.getalerttypes()
            .then(response => {
                setAlertTypes(response?.data);
                setEditAlert(currentAlert);
                showChangeAlertTypeModal();
            })
            .catch(e => {
                console.log(e);
            });
    }

    const showChangeAlertTypeModal = () => {
        setShowChangedAlertType(!showChangedAlertType);
    }
    
    const EscalateAlertClick = async (typeId, escalate) => {
        //create request, send to api, display result in snackbar
        let request = {
            alert: editAlert,
            newAlertTypeId: typeId,
            escalatedById: userId,
            escalatedByName: currentUser?.firstName + " " + currentUser?.lastName,
            date: moment().format()
        }
        await AlertService.escalatetotriage(request)
            .then(async response => {
                let message = "";
    
                if (response.data === true) {
                    message = "Successfully escalated to triage!";
                    Event("Escalate Alert Clicked", "User clicked escalate alert in Analytic Alerts page", "Escalate Alert Clicked");
                    populateAlertData();
                }
                else {
                    message = "Failed to escalate to triage!";
                }
                setStatusMessage(message);
                setShowMessage(true);
                setShowChangedAlertType(false);
    
                setTimeout(() => {
                    setStatusMessage("");
                    setShowMessage(false);
                }, 3000);
    
            })
            .catch(e => {
                console.log(e);
            });
        
        setTimeout(() => {
            setStatusMessage("");
            setShowMessage(false);
        }, 3000);
    }
    
    function getSummarizedAlerts() {
        let alert = currentAlert;
        let alerts = [];
        if (alert !== null && alert !== undefined && alert !== jsAlert && alert.alertId !== "" ) {
            if (alert.typeId !== null && alert.assetId !== null && consolidateAlertsDict[alert.typeId] !== undefined )
            {
                let consolidatedAlerts = consolidateAlertsDict[alert.typeId][alert.assetId];

                if (consolidatedAlerts?.length > 1) {
                    alerts = consolidatedAlerts;
                }
            }
        }
        return (alerts);
    }
    
    function getAddress() {
        let addy = "";

        if (currentCustomer.address !== "" && currentCustomer.address !== null) {
            addy = currentCustomer.address;

            if (currentCustomer.city !== "" && currentCustomer.city !== null) {
                addy += ", " + currentCustomer.city;
            }

            if (currentCustomer.state !== "" && currentCustomer.state !== null) {
                addy += ", " + currentCustomer.state;

                if (currentCustomer.zip !== "" && currentCustomer.zip !== null)
                    addy += " " + currentCustomer.zip;
            }
        }
        return (addy);
    }
    
    const getIsSensorAlert = () => {
        return currentAlert.typeId === blowerCurrentAlertTypeId.toString() || currentAlert.typeId === inducerCurrentAlertTypeId.toString() || currentAlert.typeId === multiSensorAlertTypeId.toString();
    }

    const getExpandContent = (index, alert) => {
        if (isSelected === index) {
            let closeButton = <div>
                <button className="secondary-btn btn-small btn-width-height"  onClick={() => openCloseAlertModal(currentAlert)}>Close Alert</button>
            </div>;

            let summarizedAlerts = getSummarizedAlerts();
            let viewAlertsButton = summarizedAlerts?.length > 1 ?
                <div>
                    <button className="secondary-btn btn-small btn-width-height"  onClick={() => openSummarizedAlertsModal(currentAlert)}>View Alerts</button>
                </div>
                : null;
                
            let remapButton = alert.typeId === blowerCurrentAlertTypeId.toString() || alert.typeId === inducerCurrentAlertTypeId.toString() ?  
                <div>
                    <button className="secondary-btn btn-small btn-width-height"  onClick={() => openRemapSensorsModal(currentAlert)}>Remap Sensors</button>
                </div>
                : null;

            let repairButton = alert.typeId === multiSensorAlertTypeId.toString() ? 
                <div>
                    <button className="secondary-btn btn-small btn-width-height"  onClick={() => openRepairSensorMapModal(currentAlert)}>Repair Sensors</button>
                </div>
                : null;
                
            let escalateButton = <div>
                <button className="secondary-btn btn-small btn-width-height"  onClick={() => openChangeAlertTypeModal(currentAlert)}>Escalate Alert</button>
            </div>

            let content = alertDetailLoading ?
                <td colSpan={10} className={"color-unset"}>
                    <div className={"row justify-content-center"}>
                        <div className="dot-flashing"></div>
                    </div>
                </td>
                : <td colSpan={10} className={"color-unset"}>
                    <div className="row">
                        <div className="col">
                            <h6 className="db-blue">Customer</h6>
                            <p><span className={"color-grey"}>Name</span><br />
                                {currentCustomer.name}
                            </p>
                            <p><span className={"color-grey"}>Phone Number</span><br />
                                {currentCustomer.phone}
                            </p>
                            <p><span className={"color-grey"}>Email</span><br />
                                {currentCustomer.email}
                            </p>
                            <p><span className={"color-grey"}>Address</span><br />
                                {getAddress()}
                            </p>
                        </div>
                        <div className="col">
                            <h6 className="db-blue">Asset</h6>
                            <p>
                                <span className={"color-grey"}>Make</span><br />
                                {currentAsset.make}
                            </p>
                            <p><span className={"color-grey"}>Model</span><br />
                                {currentAsset.model}
                            </p>
                            <p><span className={"color-grey"}>Manufacturing Date</span><br />
                                {currentAsset.mfgDate}
                            </p>
                        </div>
                        <div className="col-4">
                            <h6 className="db-blue">Alert Details</h6>
                            <p><span className={"color-grey"}>Possible Causes</span><br />
                                {alertMsgObj.possibleCauses}
                            </p>
                            <p><span className={"color-grey"}>Suggested Technician Action</span><br />
                                {alertMsgObj.techAction}
                            </p>
                            <p><span className={"color-grey"}>Suggested Homeowner Action</span><br />
                                {alertMsgObj.homeownerAction}
                            </p>
                            <p><span className={"color-grey"}>Risk</span><br />
                                {alertMsgObj.risk}
                            </p>

                        </div>
                        <div className="col-2">
                            <h6 className="db-blue">Take Action</h6>
                            <div>
                                <ViewGraphButton currentAlert={currentAlert} currentAsset={currentAsset} buttonContent="View Graphs" buttonId={0} isSensorAlert={getIsSensorAlert()}
                                                 buttonFormat={null} show={showGraph} showGraphModal={showGraphModal} _isMounted={_isMounted} acSelected={acSelected} />
                                {closeButton}
                                {viewAlertsButton}
                                {remapButton}
                                {repairButton}
                                {escalateButton}
                                
                            </div>
                        </div>
                    </div>
                </td>;

            return (
                <tr className="expanded background-white" key={`expandedContent-${index}`}>
                    {content}
                </tr>
            );
        }
        else
            return (<div>{null}</div>);
    }
    
    const getSeverity = (row) => {
        let alertMsgObj = alertMessaging.find(a => a.id.toString() === row.typeId);
        if (alertMsgObj !== null && alertMsgObj !== undefined) {
            if (alertMsgObj.severity === "Critical") {
                return (<Tooltip title="Critical" enterDelay={600} leaveDelay={200}>
                        <NotificationIcon className="db-red db-red-bg alerts-severity-icon" />
                    </Tooltip>
                );
            }
            else {
                return (<Tooltip title="Warning" enterDelay={600} leaveDelay={200}>
                        <NotificationIcon className="db-orange db-orange-bg alerts-severity-icon" />
                    </Tooltip>
                );
            }
        }
        return (<Tooltip title="Warning" enterDelay={600} leaveDelay={200}>
            <NotificationIcon className="db-orange db-orange-bg alerts-severity-icon" />
        </Tooltip>);
    }
    
    const getProblem = (row) => {
        let alertMsgObj = alertMessaging.find(a => a.id.toString() === row.typeId);
        let alertMsg = "";
        if (alertMsgObj !== null && alertMsgObj !== undefined && alertMsgObj.alertMessage !== null && alertMsgObj.alertMessage !== undefined) {
            alertMsg = alertMsgObj.alertMessage;
        }
        return alertMsg;
    }
    
    const getCount = (row) => {
        if (row.count !== undefined && row.count !== null) {
            return row.count;
        }
        return consolidateAlertsDict[row.typeId] !== undefined && consolidateAlertsDict[row.typeId][row.assetId] !== undefined ? consolidateAlertsDict[row.typeId][row.assetId].length : 0;
    }
    
    const formatDate = (rowDate) => {
        let d = new Date(rowDate);
        let month = d.getMonth() + 1;

        let date = month + "/" + d.getDate() + "/" + d.getFullYear() + " " + d.toLocaleTimeString('en-US');

        if (rowDate === "" || rowDate === null) {
            return (<div className={"color-red"}>Active</div>);
        }
        else {
            return (date);
        }
    }

    const tableColumns =  [
        { 
            field: 'severity', 
            header: 'SEVERITY', 
            className: 'table-shrink pad-10-0 min-width-80', 
            rowClassName: 'border-left pad-16-0-16-2', 
            sortType: ColumnSortTypes.ALPHABETICAL,
            render: (row) => <span>{getSeverity(row)}</span>
          
        },
        { field: 'organizationName', header: 'CUSTOMER', sortType: ColumnSortTypes.ALPHABETICAL },
        { 
            field: 'count', 
            header: 'COUNT', 
            sortType: ColumnSortTypes.NUMERIC, 
            render: (row) => <span>{getCount(row)}</span> ,
         
        },
        { field: 'type', header: 'ALERT', sortType: ColumnSortTypes.ALPHABETICAL },
        { 
            field: 'problem', 
            header: 'PROBLEM', 
            sortType: ColumnSortTypes.ALPHABETICAL,
            render: (row) => <span>{getProblem(row)}</span>,
        },
        { field: 'startTime', header: 'START', sortType: ColumnSortTypes.DATE, render: (row) => <span>{formatDate(row.startTime)}</span> },
        { field: 'endTime', header: 'END', sortType: ColumnSortTypes.DATE, render: (row) => <span>{formatDate(row.endTime)}</span> },
        {
            field: 'isActive',
            header: '',
            sortable: false,
            className: 'table-shrink text-center pad-10-10-10-5',
            rowClassName: 'alerts-td-right',
            render: (row, index) => index === isSelected ?
                <ArrowUpIcon className="db-blue-reverse border-radius-12"  />
                : <ArrowDownIcon className="db-blue db-blue-bg border-radius-12"  />
        }
    ]
    
    return (
        <div>
            <div className='infoPage'>
                <div className="row no-gutters">
                    <div className="col">
                        <h2 className="pageTitle pageTitle-border-none" id="tabelLabel">
                            Analytic Alerts
                        </h2>
                    </div>
                </div>

                <div className="analytic-alerts-table">
                    <CommonExpandTable data={alertList} columns={tableColumns} tableOptionsContent={null} itemsPerPage={25}
                                       onRowClick={onAlertClick} selected={isSelected} getExpandContent={getExpandContent} clearSelected={clearSelected}
                    />
                </div>
                
                {contentLoading ? <Loader/> : null}

                <SensorMapModal show={showRepairSensorMapConfirm} loading={sensorsLoading} sensorList={sensorList}
                                unmappedProperties={unmappedProperties} mapDict={mapDict} mapSensor={mapSensor}
                                updateSensorMap={onRepairSensorMapClick} onClick={showRepairSensorMapModal}
                                currentSensor={currentSensor} mappedSensors={mappedSensors} />
                <SummarizedAlertsModal show={showSummarizedAlerts} onClick={showSummarizedAlertsModal} alertList={getSummarizedAlerts()} analyticAlerts={true} ></SummarizedAlertsModal>
                <ConfirmationModal show={showCloseAlertConfirm} onYes={onCloseAlert} onClick={showCloseAlertModal} message={modalMessage} title={modalTitle}></ConfirmationModal>
                <ConfirmationModal show={showRemapSensorConfirm} onYes={onRemapSensorsClick} onClick={showRemapSensorsModal} message={modalMessage} title={modalTitle}></ConfirmationModal>
                <Snackbar open={showMessage} message={statusMessage} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={6000} />
                <AlertTypeModal show={showChangedAlertType} selectedTypeId={currentAlert?.typeId} alertTypes={alertTypes} onChangeAlertType={EscalateAlertClick} onClick={showChangeAlertTypeModal} fromTriage={false}></AlertTypeModal>
            </div>
        </div>
    )
}

export default AnalyticAlerts;